<template>
  <d-modal
    size="lg"
    :class="{ 'big-popup': true, 'is-hidden': isHidden }"
    @close="handleClose">
    <d-modal-header class="px-4">
      <d-modal-title>
        {{ listConfig.title || 'Ładowanie listy...' }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="px-4">
      <d-alert
        v-if="loadError"
        show
        theme="warning"
        class="mb-4">
        Wczytywanie danych nie powiodło się.
        <a href="javascript:window.location.reload();" class="alert-link">
          Odśwież stronę
        </a>
        aby spróbować ponownie.
      </d-alert>
      <template v-else>
        <div
          v-if="!loaded"
          class="text-center py-5 text-primary">
          <div
            class="spinner-border spinner-border-sm mr-2 mt-1"
            role="status">
          </div>
          Trwa ładowanie danych&hellip;
        </div>

        <div v-else>
          <d-card style="width: 100%;">
            <table class="table mt-0 mb-0 full-width">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0 align-middle pl-4">Klient/Zamówienie</th>
                  <th scope="col" class="border-0 align-middle text-center">Liczba produktów</th>
                  <th scope="col" class="border-0 align-middle text-center">Data złożenia zamówienia</th>
                  <th scope="col" class="border-0 align-middle text-center">Ostateczny termin wykonania</th>
                  <th scope="col" class="border-0 align-middle pr-4 text-center" style="width: 85px;">Akcje</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(order, index) of ordersList"
                  :key="'order-' + index">
                  <td class="align-middle py-lg-1 py-md-3 py-3 pl-4">
                    <span>{{ order.customer_name }}</span>
                    <br>
                    <small class="text-muted">{{ order.order_name }}</small>
                  </td>
                  <td class="align-middle text-center py-lg-1 py-md-3 py-3">
                    {{ order.products_count }}
                  </td>
                  <td class="align-middle text-center py-lg-1 py-md-3 py-3">
                    {{ prepareDateString(order.created_at) }}
                  </td>
                  <td class="align-middle text-center py-lg-1 py-md-3 py-3">
                    <span :class="{'text-danger font-weight-bold': isPastDeadline(order.deadline)}">
                      {{ prepareDateString(order.deadline) }}
                    </span>
                  </td>
                  <td class="align-middle text-center py-lg-1 py-md-3 py-3 pr-4">
                    <d-button
                      theme="primary"
                      @click.native="$router.push('/zamowienia/edycja/' + order.id)"
                      title="Edytuj">
                      <i class="material-icons">edit</i>
                    </d-button>
                  </td>
                </tr>
                <tr v-if="ordersList.length === 0">
                  <td
                    colspan="5"
                    class="text-center px-4 py-4">
                    Brak elementów do wyświetlenia&hellip;
                  </td>
                </tr>
              </tbody>
            </table>
          </d-card>

          <pagination :meta-data="paginationMetaData" class="mt-3" />
        </div>
      </template>
    </d-modal-body>
  </d-modal>
</template>

<script>
import ListUtils from '@/utils/ListUtils.js';
import HasPagination from '@/mixins/HasPagination.vue';
import Pagination from '@/components/common/Pagination.vue';

export default {
  name: 'orders-popup',
  mixins: [
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  computed: {
    listConfig () {
      if (!this.listKey) {
        return {
          title: '',
          endpoint: null
        };
      }
      switch (this.listKey) {
        case 'new_orders':
          return {
            title: 'Lista nowych zamówień',
            endpoint: '/api/dashboard/stats/new-orders'
          };
        case 'waiting_samples':
          return {
            title: 'Lista zamówień oczekujących na próbę',
            endpoint: '/api/dashboard/stats/waiting-samples'
          };
        case 'waiting_accept_samples':
          return {
            title: 'Lista zamówień oczekujących na akceptację próby',
            endpoint: '/api/dashboard/stats/waiting-accept-samples'
          };
        case 'waiting_dst':
          return {
            title: 'Lista zamówień oczekujących na DST',
            endpoint: '/api/dashboard/stats/waiting-dst'
          };
        case 'waiting_products':
          return {
            title: 'Lista zamówień oczekujących na produkty',
            endpoint: '/api/dashboard/stats/waiting-products'
          };
        case 'deadline_passed':
          return {
            title: 'Lista zamówień po terminie realizacji',
            endpoint: '/api/dashboard/stats/deadline-passed'
          };
        case 'waiting_additional_products':
          return {
            title: 'Lista zamówień oczekujących ponownie na produkty',
            endpoint: '/api/dashboard/stats/waiting-additional-products'
          };
        default:
          return {
            title: 'Lista zamówień',
            endpoint: '/api/orders/services/items'
          };
      }
    }
  },
  data () {
    return {
      isHidden: true,
      listKey: '',
      loaded: false,
      loadError: false,
      ordersList: []
    };
  },
  mounted () {
    this.$bus.$on('orders-stats-list-popup-show', this.openPopup);
    this.$bus.$on('pagination-page-changed', this.loadItemsData);
  },
  methods: {
    prepareDateString (input) {
      if (input === null) {
        return '-';
      }
      input = new Date(input);

      return [
        input.getFullYear(),
        input.getMonth() + 1,
        input.getDate()
      ]
        .map(n => n < 10 ? '0' + n : n)
        .join('-');
    },
    isPastDeadline (deadlineDate) {
      if (!deadlineDate) {
        return false;
      }
      return new Date(deadlineDate) < new Date();
    },
    handleClose () {
      this.loaded = false;
      this.loadError = false;
      this.isHidden = true;
    },
    openPopup (listKey) {
      this.listKey = listKey;
      this.currentPage = 1;

      this.loadItemsData();

      setTimeout(() => {
        this.isHidden = false;
      }, 0);
    },
    loadItemsData () {
      const baseEndpoint = this.listConfig.endpoint;
      if (!baseEndpoint) {
        return;
      }

      this.loaded = false;
      this.loadError = false;

      ListUtils.loadItemsData(this, {
        method: 'get',
        endpoint: `${baseEndpoint}?page=${this.currentPage}`,
        listField: 'ordersList',
        pagination: true
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('orders-stats-list-popup-show', this.openPopup);
    this.$bus.$off('pagination-page-changed', this.loadItemsData);
  }
}
</script>

<style lang="scss" scoped>
.modal.is-hidden {
  display: none;
  pointer-events: none;
}

.modal-body {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
}
</style>
